import { DeviceVendor } from './matchDevice';
import { RegisteredNpi } from './npi';
import { Organization } from './organization';

export enum UserRole {
  InternalApiAccess = 'roles:internal:api-access',
  InternalSuperAdmin = 'roles:internal:super-admin',
  InternalAdmin = 'roles:internal:admin',
  InternalClinical = 'roles:internal:clinical',
  InternalNonClinical = 'roles:internal:non-clinical',
  ExternalAdmin = 'roles:external:admin',
  ExternalPractitionerAdmin = 'roles:external:practitioner-admin',
  ExternalPractitioner = 'roles:external:practitioner',
  ExternalProvider = 'roles:external:provider',
  ExternalNonPractitionerAdmin = 'roles:external:non-practitioner-admin',
  ExternalNonPractitioner = 'roles:external:non-practitioner',
  ExternalNonProvider = 'roles:external:non-provider',
  ExternalClerical = 'roles:external:clerical',
  ExternalHeartFailure = 'roles:external:heart-failure'
}

export const PRACTITIONER_SIGNATURE_ROLES: UserRole[] = [
  UserRole.ExternalPractitionerAdmin,
  UserRole.ExternalPractitioner,
  UserRole.ExternalProvider
];
export const PRACTITIONER_SIGNATURE_ROLES_TEMP: UserRole[] = [
  UserRole.ExternalPractitionerAdmin,
  UserRole.ExternalPractitioner,
  UserRole.ExternalNonPractitioner,
  UserRole.ExternalProvider
];

export const NON_PRACTITIONER_SIGNATURE_ROLES: UserRole[] = [
  UserRole.ExternalNonPractitionerAdmin,
  UserRole.ExternalNonPractitioner,
  UserRole.InternalClinical,
  UserRole.InternalSuperAdmin,
  UserRole.InternalAdmin,
  UserRole.ExternalAdmin
];

export const NonClinicalRoles: UserRole[] = [UserRole.InternalNonClinical];

export const ADD_EDIT_RESTRICTED_ROLES: UserRole[] = [
  UserRole.InternalNonClinical,
  UserRole.ExternalClerical,
  UserRole.ExternalHeartFailure
];

export interface User {
  id: string;
  externalId?: string;
  email: string;
  family: string;
  isReviewer: boolean;
  given: string;
  name?: string;
  prefix?: string;
  suffix?: string;
  npi?: RegisteredNpi | null;
  phoneNumber?: string;
  profilePic?: string;
  role?: UserRole;
  credentials?: string[] | null;
  organizations?: Organization[] | null;
  featureFlagRole?: number;
  isExternal?: boolean;
}

export interface UserGlobalFilters {
  deviceTypes: string[];
  vendors: DeviceVendor[];
  patientStatuses: string[];
  organizations: {
    id: string;
    name: string;
  }[];
  practitioners: {
    id: string;
    given: string;
    family: string;
  }[];
  signingPractitioners: {
    id: string;
    given: string;
    family: string;
  }[];
}

export interface FindOneUserResponse extends User {
  filters: UserGlobalFilters;
}

export interface GetPractitionersQuery {
  clinicIds: string[];
  fetchAll?: boolean;
}

export type PractitionerDetails = {
  name: string;
  id: string;
};

export interface GetPractitionersResponse {
  data: PractitionerDetails[];
}
